import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowRight, ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import api from "../lib/api";
import { toast } from "sonner";

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/customer/forgot-password", { email });
            setSent(true);
            toast.success("E-mail odeslán");
        } catch {
            toast.error("Nepodařilo se odeslat e-mail");
        } finally { setLoading(false); }
    };

    return (
        <div className="min-h-screen" style={{ backgroundColor: "var(--sg-bg-light)" }}>
            <Navbar />
            <div className="max-w-md mx-auto px-4 py-10">
                <div className="bg-white border p-6" style={{ borderColor: "var(--sg-border)", borderRadius: "var(--sg-radius)" }}>
                    {sent ? (
                        <div className="text-center space-y-4" data-testid="forgot-pw-success">
                            <div className="w-14 h-14 mx-auto rounded-full flex items-center justify-center" style={{ backgroundColor: "#f0fdf4" }}>
                                <Mail size={24} style={{ color: "var(--sg-primary)" }} />
                            </div>
                            <h2 className="text-xl font-bold" style={{ color: "var(--sg-text)" }}>E-mail odeslán</h2>
                            <p className="text-sm text-gray-500">
                                Pokud ucet s touto adresou existuje, odeslali jsme vam odkaz na obnoveni hesla. Zkontrolujte svou e-mailovou schranku.
                            </p>
                            <Link to="/prihlaseni" className="inline-flex items-center gap-1 text-sm font-medium hover:underline" style={{ color: "var(--sg-primary)" }}>
                                <ArrowLeft size={14} /> Zpet na prihlaseni
                            </Link>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} className="space-y-4" data-testid="forgot-pw-form">
                            <div className="text-center mb-4">
                                <h2 className="text-xl font-bold" style={{ color: "var(--sg-text)" }}>Zapomenute heslo</h2>
                                <p className="text-sm text-gray-500">Zadejte svuj e-mail a my vam poslem odkaz na obnoveni hesla</p>
                            </div>
                            <div>
                                <Label className="text-xs text-gray-600 mb-1">E-mail</Label>
                                <div className="relative">
                                    <Mail size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                                    <Input value={email} onChange={e => setEmail(e.target.value)} type="email" placeholder="vas@email.cz"
                                        className="pl-9 h-10" required data-testid="forgot-pw-email" />
                                </div>
                            </div>
                            <Button type="submit" disabled={loading} className="w-full h-10 text-white" style={{ backgroundColor: "var(--sg-primary)" }}
                                data-testid="forgot-pw-submit">
                                {loading ? "Odesilam..." : "Odeslat odkaz"} <ArrowRight size={14} className="ml-1" />
                            </Button>
                            <div className="text-center">
                                <Link to="/prihlaseni" className="text-sm hover:underline" style={{ color: "var(--sg-primary)" }}>
                                    <ArrowLeft size={14} className="inline mr-1" />Zpet na prihlaseni
                                </Link>
                            </div>
                        </form>
                    )}
                </div>
            </div>
            <Footer />
        </div>
    );
}
